import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";

const logger = LazyLoadingSectionLogger.create(LoggingSection.core);

/**
 * TODO-rites
 */
export class LogicalOperations {
    public static binaryOperation(operator: LogicalOperator, operandA: boolean, operandB: boolean): boolean {
        switch (operator) {
            case LogicalOperator.and:
                return LogicalOperations._logicalAnd(operandA, operandB);
            case LogicalOperator.or:
                return LogicalOperations._logicalOr(operandA, operandB);
            default:
                logger.log("Performing unknown logical operation. Returning false.");
                return false; // TODO-rites: false?
        }
    }

    //TODO-rites: zkontrolovat jako to ladí s binaryOperationOverFunctions
    public static binaryOperationOverRange(operator: LogicalOperator, operands: boolean[]): boolean | null {
        const operandsCount = operands.length;
        if (operandsCount <= 0)
            return null;
        const terminator: ArnoldSchwarzenegger = LogicalOperations._getMinimalEvaluationTerminator(operator);

        let result = operands[0];

        for (let i = 1; i < operandsCount; ++i) {
            const operand = operands[i];
            if (operand == null)
                continue;

            if (result === terminator)
                return result;

            const subResult: boolean | null = LogicalOperations.binaryOperation(operator, result, operand);

            if (subResult != null)
                result = subResult;
        }

        return result;
    }

    public static binaryOperationOverFunctions(operator: LogicalOperator, functions: (() => boolean)[]): boolean | null {
        const functionsCount = functions.length;
        if (functionsCount <= 0)
            return null;
        const terminator: ArnoldSchwarzenegger = LogicalOperations._getMinimalEvaluationTerminator(operator);

        let result = functions[0]();

        for (let i = 1; i < functionsCount; ++i) {
            const functionResult = functions[i]();
            if (functionResult == null)
                continue;

            if (result === terminator && terminator != null)
                return result;

            let subResult: boolean | null;
            if (result == null) // Pokud je výsledek první funkce null, nemá smysl ho kombinovat s výsledkem aktuální funkce
                subResult = functionResult;
            else
                subResult = LogicalOperations.binaryOperation(operator, result, functionResult);

            if (subResult != null)
                result = subResult;
        }

        return result;
    }

    public static async binaryOperationOverAsyncFunctions(operator: LogicalOperator, asyncFunctions: (() => Promise<boolean> | boolean)[]): Promise<boolean | null> {
        const functionsCount = asyncFunctions.length;
        if (functionsCount <= 0)
            return null;
        const terminator: ArnoldSchwarzenegger = LogicalOperations._getMinimalEvaluationTerminator(operator);

        //TODO-rites: zvážit možnost nechat vyhodnotit overrides(nebo obecně async funkce) paralelně - Promise.all

        let result = await asyncFunctions[0]();

        for (let i = 1; i < functionsCount; ++i) {
            const functionResult = await asyncFunctions[i]();
            if (functionResult == null)
                continue;

            if (result === terminator && terminator != null)
                return result;

            let subResult: boolean | null;
            if (result == null) // Pokud je výsledek první funkce null, nemá smysl ho kombinovat s výsledkem aktuální funkce
                subResult = functionResult;
            else
                subResult = LogicalOperations.binaryOperation(operator, result, functionResult);

            if (subResult != null)
                result = subResult;
        }

        return result;
    }

    private static _getMinimalEvaluationTerminator(operator: LogicalOperator): boolean | null {
        switch (operator) {
            case LogicalOperator.and:
                return false;
            case LogicalOperator.or:
                return true;
            default:
                return null;
        }
    }

    private static _logicalAnd(operandA: boolean, operandB: boolean): boolean {
        return operandA && operandB;
    }

    private static _logicalOr(operandA: boolean, operandB: boolean): boolean {
        return operandA || operandB;
    }
}

export enum LogicalOperator {
    and,
    or,
}

export type ArnoldSchwarzenegger = boolean | null;
